<template>
  <div class="quest-chapter-outro">
    <div class="quest-chapter-outro__content">
      <div
        v-if="outroImageUrl"
        class="quest-chapter-outro__image">
        <img :src="outroImageUrl" alt="Chapter Complete" />
      </div>

      <div class="quest-chapter-outro__body">
        <div
          class="quest-chapter-outro__message"
          v-html="formattedOutro" />
      </div>

      <div class="quest-chapter-outro__actions">
        <button
          class="btn btn--fat"
          :class="{ 'btn--disabled': isPaused }"
          :disabled="isPaused"
          @click="handleContinue">
          {{ isLastChapter ? 'See your results' : 'Continue to Next Chapter' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import sharedStore from "components/quest/shared-store";

export default {
  name: "QuestChapterOutro",
  data() {
    return {
      sharedStore
    }
  },
  props: {
    isLastChapter: {
      type: Boolean,
      default: false
    },
    outro: {
      type: String,
      default: ""
    },
    outroImageUrl: {
      type: String,
      default: null
    }
  },

  computed: {
    formattedOutro() {
      const username = this.sharedStore.state.username;

      return (this.outro || "").replaceAll("%username%", username);
    },
    isPaused() {
      return this.sharedStore.state.questPaused;
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    handleKeydown(event) {
      // Check for CMD + Enter (Mac) or CTRL + Enter (Windows)
      if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()

        // Don't allow keyboard shortcut when paused
        if (this.isPaused) {
          return;
        }

        this.sharedStore.nextScreen();
      }
    },
    handleContinue() {
      // Don't allow continue when paused (protection against dev console manipulation)
      if (this.isPaused) {
        return;
      }

      this.sharedStore.nextScreen();
    }
  }
}
</script>

<style lang="scss" scoped>
.quest-chapter-outro {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: $px48 0;

  &__content {
    max-width: 600px;
    width: 100%;
  }

  &__image {
    margin-bottom: $px32;

    img {
      display: block;
      max-width: 100%;
      height: auto;

      border-radius: $px8;
    }
  }

  &__message {
    margin-bottom: $px48;

    @include font-regular;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: $px16;
  }
}
</style>
